const PRIORITY = ['English', 'Mandarin', 'Malay', 'Tamil', 'Cantonese'];

const SOUTHEAST_ASIA = ['Bahasa Indonesia', 'Thai', 'Vietnamese', 'Filipino', 'Burmese', 'Khmer', 'Lao', 'Hokkien', 'Teochew', 'Hakka'];

const REST_OF_WORLD = [
  'Japanese',
  'Korean',
  'Hindi',
  'Bengali',
  'Urdu',
  'Punjabi',
  'Spanish',
  'French',
  'German',
  'Portuguese',
  'Italian',
  'Dutch',
  'Swedish',
  'Norwegian',
  'Danish',
  'Finnish',
  'Polish',
  'Czech',
  'Slovak',
  'Hungarian',
  'Romanian',
  'Bulgarian',
  'Greek',
  'Turkish',
  'Russian',
  'Ukrainian',
  'Arabic',
  'Hebrew',
  'Persian',
  'Swahili',
  'Amharic',
  'Nepali',
  'Sinhala',
  'Mongolian',
  'Samoan',
  'Maori',
  'Hawaiian',
];

export const LANGUAGES = [...PRIORITY, ...SOUTHEAST_ASIA, ...REST_OF_WORLD];
